import React from 'react';
import { BottomMenuView } from './BottomMenu.view';
import { BottomMenuViewProps } from './BottomMenu.view';

export const BottomMenu = ({ pagesProps }: BottomMenuViewProps) => {
  return <BottomMenuView pagesProps={pagesProps} />;
};
